// ─── Las columnas de la pestaña Inscripciones de la ficha ───────────────────
// Con `graduation_audit` (un seminario cuyo expediente viene de su sistema de
// origen) la pestaña es de SOLO LECTURA y sin nota numérica:
//   · «Nota»: la guardada son los puntos 4-3-2-1, que esta escala leería como
//     reprobados; la nota de verdad (la letra) está en la pestaña Expediente;
//   · «Acciones» (dar de baja): las inscripciones importadas se corrigen en el
//     sistema de origen, no aquí.
// Sin el flag —todos los demás seminarios— las columnas son las de siempre.

export type EnrollmentColumn =
  | 'course'
  | 'program'
  | 'faculty'
  | 'start'
  | 'end'
  | 'grade'
  | 'status'
  | 'actions';

const ALL: readonly EnrollmentColumn[] = [
  'course',
  'program',
  'faculty',
  'start',
  'end',
  'grade',
  'status',
  'actions',
];

export function enrollmentColumns(opts: { importedRecord: boolean }): EnrollmentColumn[] {
  return opts.importedRecord ? ALL.filter((c) => c !== 'grade' && c !== 'actions') : [...ALL];
}
